import React from "react";
import { useRoutes } from "react-router-dom";
import NotFound from "pages/NotFound";
import LandingpageWIP from "pages/LandingpageWIP";
import Formnew from "pages/Formnew";
import Confirmationatsubmitform from "pages/Confirmationatsubmitform";
import Tocome from "pages/Tocome";
import Terms from "pages/Terms/Terms";
import Privacy from "pages/Privacy/Privacy";
import CookiePolicy from "pages/Cookie/CookiePolicy";

const ProjectRoutes = () => {
  let element = useRoutes([
    { path: "/", element: <LandingpageWIP /> },
    { path: "*", element: <NotFound /> },
    {
      path: "landingpagewip",
      element: <LandingpageWIP />,
    },
    {
      path: "formnew",
      element: <Formnew />,
    },
    {
      path: "confirmationatsubmitform",
      element: <Confirmationatsubmitform />,
    },
    {
      path: "tocome",
      element: <Tocome />,
    },
    {
      path:"terms",
      element: <Terms />,
    },
    {
      path:"privacy",
      element: <Privacy />,
    },
    {
      path:"cookiepolicy",
      element: <CookiePolicy />,
    }
   
    
  ]);

  return element;
};

export default ProjectRoutes;
